import { PagedMultiSelectField, laravelServiceSelectFetchConfig } from "@dgs/core";
import { FC } from "react";
import { targetGroupService } from "../api/targetGroupService";

const fetchConfig = laravelServiceSelectFetchConfig(targetGroupService);

interface Props {
	name: string;
	label: string;
	required?: boolean;
}

export const TargetGroupMultiSelectField: FC<Props> = (props) => {
	return <PagedMultiSelectField {...props} fetchConfig={fetchConfig} />;
};
